import { render, staticRenderFns } from "./LocationMenuLinks.vue?vue&type=template&id=33c8702c&"
import script from "./LocationMenuLinks.vue?vue&type=script&lang=js&"
export * from "./LocationMenuLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33c8702c')) {
      api.createRecord('33c8702c', component.options)
    } else {
      api.reload('33c8702c', component.options)
    }
    module.hot.accept("./LocationMenuLinks.vue?vue&type=template&id=33c8702c&", function () {
      api.rerender('33c8702c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/LocationMenuLinks.vue"
export default component.exports